export const openAdmissionForm = ({ classValue = "", lockClass = false } = {}) => {
  const event = new CustomEvent("openAdmissionForm", {
    detail: { classValue, lockClass },
  });
  window.dispatchEvent(event);
};

export const openAdmissionFormForClassXI = () =>
  openAdmissionForm({ classValue: "11", lockClass: true });
